module.exports = __webpack_public_path__ + "img/logo.03013f82.png";